import { NextPage } from 'next'
import Index, { getServerSideProps } from '../index'
import { IndexProps } from '../../types/IndexProps'

const Apply: NextPage<IndexProps> = Index

export { getServerSideProps }

export default Apply
